"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    accessToken: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_ACCESS_TOKEN] = function (state, action) { return action.payload; },
        _a), ''),
    user: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_USER] = function (state, action) { return action.payload; },
        _b), null),
    error: api_1.createCustomModuleReducer((_c = {},
        _c[constants_1.SET_ACCESS_TOKEN] = function () { return null; },
        _c[constants_1.UNAUTHORIZED_ERROR] = function (state, action) { return action.payload; },
        _c), null),
    config: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_CONFIG,
        onSuccess: function (draftState, action) {
            draftState.data = action.payload;
        },
    })), api_1.createApiInitialState(null)),
    isLoading: api_1.createCustomModuleReducer((_d = {},
        _d[constants_1.SET_AUTH_LOADING] = function (state, action) { return action.payload; },
        _d), null),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map